import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from '../auth/services/auth.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  standalone: true,
  imports: [RouterOutlet, MatSidenavModule, TranslateModule, JsonPipe],
})
export class DashboardComponent implements OnInit {
  private readonly authService = inject(AuthService);

  constructor() {}

  ngOnInit(): void {}
}
